import React from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import FooterBlack from "components/Footers/FooterBlack.js";

function AboutUs() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="edge-page">
      <div className="edge-page-brand-nav">
        <Container>
          <Link to="/presentation">Edge<span>Ventures</span></Link>
        </Container>
      </div>
      <section className="edge-page-hero">
        <Container>
          <span className="edge-page-eyebrow">{"// who we are"}</span>
          <h1 className="edge-page-title">
            About <span>Edge Ventures</span>
          </h1>
          <p className="edge-page-subtitle">
            A small Los Angeles studio specializing in data architecture, AI
            automation, and full-stack app development. Founded by Don Rickman,
            a data architect with 10+ years building systems that scale.
          </p>
          <Link to="/contact" className="ep-btn-primary">
            Work with us →
          </Link>
        </Container>
      </section>

      <section className="edge-page-body">
        <Container>
          <div className="edge-stub-card">
            <div className="edge-stub-icon">
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <h3>Full story coming soon</h3>
            <p>
              We're writing up the Edge Ventures story — the clients, the
              projects, and the philosophy behind how we build. In the meantime,
              the homepage has a solid overview.
            </p>
            <Link to="/presentation" className="ep-btn-ghost">
              ← Back to home
            </Link>
          </div>
        </Container>
      </section>

      <FooterBlack />
    </div>
  );
}

export default AboutUs;
